import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/styles";

const CustomLoading = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        position: "absolute",
        top: theme.mixins.toolbar.top,
        left: "49%",
        zIndex: 999,
      }}
    >
      <CircularProgress />
    </div>
  );
};
export default CustomLoading;
